import { Grid } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import fetchData from "../../shared/fetchData";
import ContentForm from "../UI/ContentForm/ContentForm";
import SelectBox from "../UI/Select/Select";
import Input from "../UI/Input/Input";
import Button from "../UI/Button/Button";
import Modal from "../UI/Modal/Modal";
import { updateObject } from "../../shared/utility";


const KioskUnitForm = (props) => {

    const [loading, setLoading] = useState(false)
    const [rerender, setRerender] = useState(false)
    const [invalidSelectBox, setInvalidSelectBox] = useState(false)
    const [kiosks, setKiosks] = useState([])
    const [kiosk, setKiosk] = useState('')
    const [units, setUnits] = useState([])
    const [unit, setUnit] = useState('')
    const [modalContent, setModalContent] = useState('')
    const [kioskUnit, setKioskUnit] = useState({
        maxCount: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'تعداد'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
    })

    const childRef = useRef();

    useEffect(() => {
        setLoading(true)
        var raw = JSON.stringify({
            "pl": "10000",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        fetchData(raw, url).then(response => response.json())
            .then(result => {
                var url = 'management/api/v1/kiosks/getKiosks'
                fetchData(raw, url).then(response => response.json())
                    .then(result1 => {
                        setUnits(result.units);
                        setKiosks(result1.kiosks);
                        if (!!props.edit && props.edit) {
                            const kskUnit = kioskUnit;
                            kskUnit.maxCount.value = props.kioskUnit.maxCount;
                            setKioskUnit(kskUnit);
                            const unt = result.units.filter(u => u.id === props.kioskUnit.unitId);
                            if (!!unt && unt.length != 0) {
                                setUnit({
                                    value: unt[0].id,
                                    label: unt[0].unitName
                                })
                            }
                            const ksk = result1.kiosks.filter(u => u.id === props.kioskUnit.kioskId);
                            if (!!ksk && ksk.length != 0) {
                                setKiosk({
                                    value: ksk[0].id,
                                    label: ksk[0].description
                                })
                            }
                            setRerender(!rerender)
                            setLoading(false)
                        } else {
                            setUnit('');
                            setKiosk('');
                            const kskUnit = kioskUnit;
                            kskUnit.maxCount.value = '';
                            setKioskUnit(kskUnit);
                            setRerender(!rerender)
                        }
                    })
                    .catch(error => setLoading(false))
            })
            .catch(error => setLoading(false))
    }, [props]);

    const changeUnit = (selectedOption) => {
        setUnit(selectedOption);
    }

    const changeKiosk = (selectedOption) => {
        setKiosk(selectedOption);
    }

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(kioskUnit, {
            [controlName]: updateObject(kioskUnit[controlName], {
                value: event.target.value,
                valid: true,
            })
        });
        setKioskUnit(updatedControls)
    }

    const insertOrUpdateKioskUnit = () => {

        let valid = true;
        const kskUnt = kioskUnit;
        for (let k in kskUnt) {
            if (kskUnt[k].value == '') {
                kskUnt[k].valid = false;
                valid = false;
            }
        }
        if (unit == '' || unit == null) {
            setInvalidSelectBox(true);
            valid = false;
        }
        if (kiosk == '' || kiosk == null) {
            setInvalidSelectBox(true);
            valid = false;
        }
        if (valid) {
            var raw = JSON.stringify({
                kioskUnit: {
                    id: !!props.edit && props.edit ? props.kioskUnit.id : '',
                    unitId: !!unit && unit != '' ? unit.value : '',
                    kioskId: !!kiosk && kiosk != '' ? kiosk.value : '',
                    maxCount: kioskUnit.maxCount.value
                },
                "version": "mtpx001"
            })
            var url = !!props.edit && props.edit ? 'management/api/v1/kioskunits/updateKioskUnit' : 'management/api/v1/kioskunits/insertKioskUnit'
            setLoading(true)
            fetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == '0') {
                        props.reload();
                        setLoading(false)
                    } else if (result.message == 'DUPLICATE_DATA') {
                        setModalContent(<div className="row justify-content-center mt-3 mb-3" style={{ color: 'red' }}>
                            با این حساب و لاکر رکورد ثبت شده است
                        </div>);
                        childRef.current.openModal();
                    }
                })
                .catch(error => setLoading(false))
        } else {
            setKioskUnit(kskUnt);
            setRerender(!rerender)
        }
    }

    const afterCloseModal = () => { }

    let unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }

    let kioskList = []
    if (kiosks != null && kiosks.length != 0) {
        kiosks.map(z => {
            kioskList.push({
                value: z.id,
                label: z.description
            })
        })
    }

    const formElementsArray = [];
    for (let key in kioskUnit) {
        formElementsArray.push({
            id: key,
            config: kioskUnit[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        let col = '4 mt-2'
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col={col}
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        )
    })

    return (
        <div className="row justify-content-center">
            <Grid lg={6} xs={11} >
                <ContentForm headetText='اطلاعات محدودیت حساب'>
                    <SelectBox
                        name="form-field-name"
                        value={unit}
                        placeholder="حساب"
                        options={unitList}
                        onChange={changeUnit}
                        col="4 mt-2"
                        className={invalidSelectBox && (unit == '' || unit == null) ? "invalid-select" : ""}
                    />
                    <SelectBox
                        name="form-field-name"
                        value={kiosk}
                        placeholder="لاکر"
                        options={kioskList}
                        onChange={changeKiosk}
                        col="4 mt-2"
                        className={invalidSelectBox && (kiosk == '' || kiosk == null) ? "invalid-select" : ""}
                    />
                    {form}
                    <div className="row justify-content-center mt-3 w-100">
                        <Grid lg={4} xs={5} className="text-center" >
                            <Button btnType="General" clicked={() => { props.back() }} >برگشت</Button>
                        </Grid>
                        <Grid lg={4} xs={5} className="text-center" >
                            <Button btnType="Success" clicked={insertOrUpdateKioskUnit} >ثبت</Button>
                        </Grid>
                    </div>
                    <Modal
                        content={modalContent}
                        ref={childRef}
                        closePermission="true"
                        closeModal=
                        {(event) => afterCloseModal(event)}
                    />
                </ContentForm>
            </Grid>
        </div>
    )
}

export default KioskUnitForm;